export * from "./SingleOptionalConsent";
